
import Dinero from 'dinero.js'
import json_data from '../../../data.json'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconCheck from '@/components/icons/check.vue'
import IconBase from '@/components/IconBase.vue'

import IconForwardBack from '@/components/icons/arrowForward.vue'
import IconPencil from '@/components/icons/pencil.vue'
import IconCustomerSupport from '@/components/icons/customerSupport.vue'

import Globals from '@/assets/scripts/global-functions.js'
import BackButton from '@/components/BackButton.vue'
import NextButton from '@/components/forms/ButtonNext.vue'
import PremiumToggle from '@/components/forms/PremiumToggle.vue'
import PremiumData from '@/components/forms/PremiumData.vue'
import PremiumSideBar from '@/components/forms/PremiumSideBar.vue'


export default {
    name: 'Quote',
    props: ['EditStatus'],
    components: {
        IconArrowBack,
        IconBase,
        IconForwardBack,
        IconPencil,
        IconCheck,
        IconCustomerSupport,
        Globals,
        BackButton,
        NextButton,
        PremiumToggle,
        PremiumData,
        PremiumSideBar,
    },
    data: () => ({
        declarations: false,
    }),
    watch: {
        // EditStatus: function(newVal, oldVal) {
        //     if (newVal == true) {
        //         var x = document.getElementById("sidebar_main_container");
        //         x.classList.add("full_width_container");
        //         x.classList.add("block")
        //     } else {
        //         var x = document.getElementById("sidebar_main_container");
        //         x.classList.remove("full_width_container");
        //         x.classList.remove("block");
        //     }
        // }
    },
    mounted() {
        //delete
        //this.$parent.EducatorInsuranceProcess = Globals.CreateLocalData(this.$parent.Role);
        this.$parent.EducatorInsuranceProcess.breakdown = {};

        this.$refs.toggle.ToggleSelected('yearly');
        this.$parent.CheckWindowPathName();
        

        //Add to PO
        this.AddToDB();

        this.$parent.CurrentProcess = "EducatorInsuranceProcess";

       
        
    },
    methods: {
        declarations(params){
            this.declarations(params);
        },

        AdditionalCoverCost(_total_amount){
            let additional_cover_ = this.datas.educators.packages.additional_cover;
            let ac = this.$parent.EducatorInsuranceProcess.additional_cover;
            let additional_cover_cost_ = 0;
            if(ac.length > 1){
                let  additional_cover_filter = additional_cover_.filter(ac => ac.name.indexOf('Both') >= 0);
                additional_cover_cost_ = additional_cover_filter[0].cost;
            }else if(ac.length == 1){
                let  additional_cover_filter = additional_cover_.filter(ac => ac.name.indexOf(this.additional_cover) >= 0);
                additional_cover_cost_ = additional_cover_filter[0].cost;
            }else{
                additional_cover_cost_ = 0;
            }
            this.additional_cover_cost = Dinero({
                amount: parseInt(additional_cover_cost_),
                currency: 'AUD',
                precision: 2
            }).toUnit();

            return additional_cover_cost_;
        },
        Edit() {
            this.$refs.fullwidth_sidebar.fullwidth_sidebar();
        },
        Next() {
            this.$parent.EditStatus = false;
            this.$parent.EducatorNextStep(-1,"CoordinationUnit"); 
        },

        ConvertToString(_params){
            if(_params != undefined){
                return _params.toString();
            }else{
                return "";
            }
        },
        
        AddToDB(){
            let educator = this.$parent.EducatorInsuranceProcess.Educators[0];
            let birthdate = undefined;
            if(educator.birth_year != ''){
                birthdate = educator.birth_year+'-'+educator.birth_month.value+'-'+educator.birth_day;
            }

            //add 1 to the month of expiry date/created date because in javascript January starts in 0
            var d = new Date();
            var created_date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
            var expiry_date = new Date();
            expiry_date.setDate(d.getDate()+30);
            var expiry_date_ = expiry_date.getFullYear() + '-' + (expiry_date.getMonth() + 1) + '-' + expiry_date.getDate();
            var commencement_date = new Date(educator.commencement_date);
            var commencement_date_ = commencement_date.getFullYear() + '-' + (commencement_date.getMonth() + 2) + '-' + commencement_date.getDate();



            const formdata = {
                data: JSON.stringify(this.$parent.EducatorInsuranceProcess),
                birthdate: birthdate,
                email_address: educator.email_address,
                quote_ref_num: this.$parent.EducatorInsuranceProcess.quote_ref_num,
                is_deleted: "false",
                date_expiry : expiry_date_

            }

            let CheckSessionByReferenceNumber_ = Globals.CheckSessionByReferenceNumber(this.$parent.EducatorInsuranceProcess.quote_ref_num, this.$parent.Role);

            // FIRST check if reference number is already in POS
            //if not yet existing  
            CheckSessionByReferenceNumber_.then(response => {

                if(response.data.customizations.results.length == 0){

                    let AddSession_ = Globals.AddSession(formdata, this.$parent.Role);


                    //this is not working inside addsession.then function
                    var self=this;

                    AddSession_.then(function (response) {
                        self.$parent.is_local_storage = true;
                        self.$parent.SessionUpdate();
                        self.$parent.session_id =  response.data.customization_create.id;

                    })
                    .catch(function (response) { 
                        console.error("Add Session", response);
                    });
                }else{
                    
                }
            })
            .catch(response => { 
                console.error('Check Session By Reference Number', response);
            });

        },
        OpenModal(){
            this.$parent.active_modal = 2;
        }
    }
} 